import type { StoreGeneric } from 'pinia'
import type { Router } from 'vue-router'
import type { Ref } from 'vue'

export async function handleError(
  error: Ref<Error & { code: number }>,
  router: Router,
  authStore: StoreGeneric,
  alertStore: StoreGeneric,
  notFoundRouteName?: string
) {
  if (!error.value) return
  if (error.value.code === 401) {
    await authStore.logout()
    await router.push({ name: 'account:login' })
  } else if (error.value.code === 404 && notFoundRouteName) {
    await router.push({ name: notFoundRouteName })
  } else {
    alertStore.error(error.value.message)
  }
}
